<template>
	<div id="app">
		<router-view />
		<div class="ver">Copyright © 2020 GoWork.la. All Rights Reserved. Ver 1.1.3</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
	}
</script>

<style>
	/* 侧边栏 */
	.sidebar-btn{
		display: none;
	}
	.sidebar {
		position: fixed;
		left: 3.125rem;
		top: 7rem;
		font-size: 0.875rem;
	}

	.sidebar div,
	.sidebar a {
		display: block;
		box-sizing: border-box;
		margin-bottom: 0.375rem;
		padding-left: 1rem;
		text-align: center;
		line-height: 2.125rem;
		width: 11.375rem;
		height: 2.125rem;
		border-radius: 0.125rem;
		cursor: pointer;
		border: 0.0625rem solid #5E4FFF;
		background-color: #fff;
		color: #5E4FFF;
	}

	.sidebar a:nth-of-type(1) {
		background-image: url(./assets/image/sign.png);
		background-repeat: no-repeat;
		background-position: 3.375rem center;
	}

	.sidebar a:nth-of-type(2) {
		background-image: url(./assets/image/download.png);
		background-repeat: no-repeat;
		background-position: 0.5rem center;
	}

	.sidebar .sidebar-on {
		color: #fff;
		background-color: #5E4FFF;
	}

	.sidebar .sidebar-on:nth-child(1) {
		background-image: url(./assets/image/sign-on.png);
	}

	.sidebar .sidebar-on:nth-child(2) {
		background-image: url(./assets/image/download-on.png);
	}

	@media (max-width:46.875rem) {
		.sidebar {
			display: none;
			left: 1rem;
			top: 8rem;
			font-size: 0.875rem;
			color: #5E4FFF;
		}
		.sidebar-btn{
			display: block;
			position: fixed;
			left: 0.5rem;
			top: 5rem;
			height: 2rem;
			width: 2rem;
			background: url(assets/image/menu.png) no-repeat;
		}
	}
	/* 版本号 */
	.ver{
		padding:0 0 .5em 1em;
		margin-top: -1.5em;
		color: #999;
	}
	@media (max-width:46.875rem){
		.ver{
			margin-top:0;
			font-size: 12px;
		}
	}
</style>
